import React from "react";
import { Skeleton } from "primereact/skeleton";
import { useParams } from "react-router-dom";
import { getName } from "country-list";
import ReactCountryFlag from "react-country-flag";
import { Outlet } from "react-router-dom";

import Layout from "../../Layout";
import useFileDocuments from "./actions/useFileDocuments";
import "./files_documents.scss";
import TitleBreadcrumbs from "./components/TitleBreadcrumbs";

function FileDocumentsLayout() {
  const { id } = useParams();
  const { states } = useFileDocuments({ id });
  return (
    <Layout
      crumbs={[
        { label: "My Entities", url: "/entities", id: "entities" },
        {
          label: (
            <div className="flex">
              {!states?.loading ? (
                states?.entity_detail?.name
              ) : (
                <Skeleton width="100px" height="20px" className="mr-1" />
              )}
              {!states?.loading ? (
                <>
                  (
                  <ReactCountryFlag
                    countryCode={states?.entity_detail?.country || ""}
                    svg
                  />{" "}
                  {getName(states?.entity_detail?.country || "")})
                </>
              ) : (
                <Skeleton width="150px" height="20px" className="mr-1" />
              )}
            </div>
          ),
          id: "entity",
          url: `/entity/${id}/dashboard`,
        },
        { label: "Files & Documents", id: "entity-files-document" },
      ]}
    >
      <TitleBreadcrumbs />
      <Outlet />
    </Layout>
  );
}

export default FileDocumentsLayout;
